import { Box, Button, Grid, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents"
import styles from './SearchCandidate.module.css';
import { customTextColor } from "../../utils/const";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { useNavigate } from "react-router-dom";



const ViewCandidateDetails = () => {
    const navigate = useNavigate()
    return (
        // <RootComponents>
            <Box className={styles.search_candidate_stucture}>
                <Box className={styles.job_serach_result_heading}>
                    <Typography sx={{ color: customTextColor }}>CANDIDATE DETAILS</Typography>
                </Box>
                <Grid container className={styles.profile_status}>
                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography> <b>PROFILE UPLOADED BY</b></Typography>
                        <Typography>Recruiter : <b>Ashit Kumar Rout</b></Typography>
                        <Typography>Designation : <b>Sr. Recruiter</b></Typography>
                        <Typography>Sponsored by : <b>Dinkins Solutions Pvt Ltd</b></Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography> <b>PROFILE STATUS</b></Typography>
                        <Typography>Verified by :<b>Kevin Macklin</b></Typography>
                        <Typography>Profile Updated : <b>10 August 2024</b></Typography>
                        <Typography>Candidate : <b>Depended</b></Typography>
                    </Grid>
                </Grid>

                <Grid container className={styles.matches_and_submit}>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Box>
                            <Box className={styles.submit}>
                                <Typography><b style={{ fontSize: '24px' }}>95%</b></Typography>
                                <Typography>MATCHES WITH REQUIREMENT</Typography>
                            </Box>
                            <Typography>Name : <b>Kevin Macklin</b></Typography>
                            <Typography>Phone No : <b>242-330-****</b></Typography>
                            <Typography>Experience : <b>10 Years</b></Typography>
                            <Typography>Current Location : <b>Dallas Taxes</b></Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Box>
                            <Box className={styles.submit}>
                                <Typography><b style={{ fontSize: '24px' }}>12-08-24</b></Typography>
                                <Typography>LAST SUBMITTED ON</Typography>
                            </Box>
                            <Typography>Job Profile : <b>Lead Java Developer</b></Typography>
                            <Typography>E-Mail ID : <b> kevinmaclin***@gmail.com</b></Typography>
                            <Typography>Work Authorization : <b> Green Card</b></Typography>
                            <Typography>Prefer Location : <b>San Club California, CA</b></Typography>
                        </Box>
                    </Grid>

                </Grid>

                <Grid container className={styles.profile_status}>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography>Domain : <b>Healthcare, Retail, Banking</b></Typography>
                        <Typography>Qualifications : <b>B Tech</b></Typography>
                        <Typography>Prefer Tax Term : <b>Full Time, W2, Contract</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography>Organization : <b>ABC Technologies Pvt Ltd</b></Typography>
                        <Typography>Current Rate : <b>100$</b></Typography>
                        <Typography>University : <b>Boston Texas</b></Typography>
                    </Grid>
                </Grid>
                <Box className={styles.profile_status_details_btns}>
                    <img src={profile_image} alt="" />
                    <Button
                        sx={{
                            backgroundColor: '#3861B3',
                            '&:hover': {
                                backgroundColor: '#2d4f91',
                            },
                        }}
                    >
                        View Contact
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#00b04f',
                            '&:hover': {
                                backgroundColor: '#008d39',
                            },
                        }} onClick={() => navigate('/post-request-submit')}>
                        Send Requirement
                    </Button>

                </Box>




            </Box>
        // </RootComponents>
    )
}

export default ViewCandidateDetails;